import React from 'react';
import { Icon } from '../layout/misc/Icon';
import SettingsTableSkeleton from '../settings/SettingsTableSkeleton';
import moment from 'moment-timezone';

export class TestResultsFilesTable extends React.Component {
	isColumnSorted(column) {
		if (this.props.sort && this.props.sort.column === column) {
			const icon = this.props.sort.asc ? 'fa-chevron-up' : 'fa-chevron-down';
			return <Icon icon={icon} />;
		} else {
			return null;
		}
	}

	handleHeaderClick(column) {
		if (this.props.onSort) {
			this.props.onSort(column);
		}
	}

	render() {
		return (
			<table className="table is-fullwidth">
				<thead>
					<tr>
						<th className="is-sortable" style={{ width: '40%' }}>
							File name
						</th>
						<th
							className="is-sortable"
							style={{ width: '20%', whiteSpace: 'nowrap' }}
							onClick={() => this.handleHeaderClick('createdAt')}>
							Created at {this.isColumnSorted('createdAt')}
						</th>
						<th
							className="is-sortable"
							style={{ width: '20%', whiteSpace: 'nowrap' }}>
							Updated at
						</th>
						<th
							className="is-sortable"
							style={{ width: '12%', whiteSpace: 'nowrap' }}>
							Current
						</th>
						<th
							className="actions-column"
							style={{ width: '1%', whiteSpace: 'nowrap' }}
						/>
					</tr>
				</thead>
				{this.props.loading ? (
					<SettingsTableSkeleton columns={5} />
				) : !this.props.isEmpty ? (
					<tbody>
						{this.props.data.map(item => {
							return (
								<tr key={item.id} className={item.disabled ? 'disabled' : ''}>
									<td className="has-text-weight-bold">{item.filename}</td>
									<td className="has-text-weight-medium">
										{moment(item.createdAt).fromNow()}
									</td>
									<td className="has-text-weight-medium">
										{moment(item.updatedAt).fromNow()}
									</td>
									<td className="has-text-weight-medium">
										{item.current ? 'Yes' : 'No'}
									</td>
									<td className="actions-column">
										<button
											type="button"
											title="Pin the file to be processed"
											className="button-border-soft-small is-icon-only"
											onClick={() => {
												this.props.onEdit(item);
											}}>
											<img src="/ats/icons/pin-icon.svg" alt="Pin" />
										</button>
										<button
											type="button"
											title="Download File"
											className="button-border-soft-small is-icon-only"
											onClick={() => {
												this.props.onDownload(item);
											}}>
											<img src="/ats/icons/download-icon.svg" alt="Download" />
										</button>
										<button
											type="button"
											title="Delete File"
											className="button-border-soft-small is-icon-only"
											onClick={() => {
												if (this.props.onEdit) {
													this.props.onDelete(item);
												}
											}}>
											<img src="/ats/icons/trash-icon.svg" alt="Delete" />
										</button>
									</td>
								</tr>
							);
						})}
					</tbody>
				) : null}
			</table>
		);
	}
}
